import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Solicitud } from "src/app/infraestructure/interfaces/referente/SolicitudDTO";
import { ReferentApiService } from "src/app/infraestructure/services/referent/referent-api.service";
import Swal from "sweetalert2";


@Component({
  selector: "app-pages-solicitud-servicio",
  templateUrl: "./pages-solicitud-servicio.component.html",
  styleUrls: ["./pages-solicitud-servicio.component.scss"],
})
export class PagesSolicitudServicioComponent implements OnInit {

  submitted: number = 0;

  private $topSubcription = new Subject<void>();

  constructor(
    public http: HttpClient,
    public router: Router,
    private _referentSrv: ReferentApiService
  ) { }

  ngOnInit(): void {
  }

  saveRequestService() {
    this.submitted += 1;
  }

  catchRequestService(event: Solicitud) {
    this._referentSrv.postRequestService(event)
      .pipe(takeUntil(this.$topSubcription))
      .subscribe(resp => {
        if (resp.code == 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: `Creación exitosa`,
            text: `Solicitud de servicio creada exitosamente con el #${resp.data.id}`,
            showConfirmButton: true,
            confirmButtonColor: "#004884",
            confirmButtonText: "ACEPTAR",
          });

          const currentUrl = this.router.url;
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate([currentUrl]);
          });
        } else {
          const messages = resp.errors.map((error: any) => `<li>${error.message}</li>`).join('\n');
          
          Swal.fire({
            title: 'Errores',
            icon: 'error',
            html: '<ul style="text-align: left; font-size: 0.8rem;">' + messages + '</ul>',
            showConfirmButton: true,
            confirmButtonColor: "#004884",
            confirmButtonText: "ACEPTAR",
          });
        }
      });
  }
}
